import { useEffect, useState } from 'react';

import { fetchPrivateFile, getDocumentSource } from '@libs/NwPrivateFile';

// URL con cui mostrare un documento in un <iframe>: pubblico se sta sul cloud, altrimenti
// un object URL ricavato da un GET autenticato, rilasciato allo smontaggio.
const useDocumentUrl = (doc) => {
    const { publicUrl, isPrivate } = getDocumentSource(doc);
    const [privateUrl, setPrivateUrl] = useState(null);
    const [hasError, setHasError] = useState(false);

    // Dipendenze su campi primitivi: il documento arriva da liste che cambiano riferimento a ogni render.
    useEffect(() => {
        if (!isPrivate) {
            return undefined;
        }
        let isCancelled = false;
        let objectUrl = null;
        setPrivateUrl(null);
        setHasError(false);
        fetchPrivateFile(doc)
            .then((blob) => {
                if (!isCancelled) {
                    objectUrl = URL.createObjectURL(blob);
                    setPrivateUrl(objectUrl);
                }
            })
            .catch((error) => {
                console.error('Load private file error => ', error);
                if (!isCancelled) {
                    setHasError(true);
                }
            });
        return () => {
            isCancelled = true;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [isPrivate, doc.Guid, doc.Extension, doc.Standard?.Url]);

    return { url: isPrivate ? privateUrl : publicUrl, hasError };
};

export default useDocumentUrl;
